import getIsoCode from './getIsoCode';

export default function getLocale(object: object | undefined) {
  // @ts-ignore
  return object?.[getIsoCode()] ?? object?.en;
}
